import Vue from 'vue';
import GeCtaArrow from './ge-cta-arrow';

// Main component
Vue.component('ge-cta-arrow', GeCtaArrow);

export default GeCtaArrow;



// WEBPACK FOOTER //
// ./scripts/ge-cta-arrow/index.js